<template>
  <div class="PushSettingsContainer">
    <div class="benachrichtigungen borderGrey colorGrey" v-if="routen.length !== 0">
      <div v-if="!isMobile" class="displayflex colorLightGrey">
        <SVGIcon name="benachrichtigung_grau"/>
        <div
          class="selfAlignCenter"
          style="margin-left:15px"
        >Benachrichtigungen sind auf mobilen Geräten verfügbar</div>
      </div>

      <div
        class="benachrichtigungenHeader displayflex flexbetween cursor-pointer colorBlue fontweight600 fontsize18"
        @click="extended = !extended"
        v-else
      >
        <div class="displayflex">
          <SVGIcon :name="isSubscribed ? 'benachrichtigung' : 'benachrichtigung_off'"/>
          <div class="selfAlignCenter" style="margin-left:15px">Benachrichtigungen</div>
        </div>
        <SVGIcon
          name="icon_expand_more"
          :class="['selfAlignCenter', extended ? 'rotate180' : '' ]"
        />
      </div>

      <div v-if="extended" style="padding-top:10px" class="fontsize16 marginleft50">
        <div v-if="pushPossible || pushNotifierSubscribed">
          <div class="displayflex flexbetween">
            <div
              class="selfAlignCenter fontweight600"
            >{{isSubscribed ? 'Aktiviert' : 'Deaktiviert'}}</div>
            <ToggleButton
              class="selfAlignCenter"
              :toCheck="isSubscribed"
              index="togglePush"
              @input="handlePushRegistration"
              :disabled="isLoading"
            />
          </div>

          <div class="benachrichtigungsRoutenListe">
            <div
              class="benachrichtigungsRoute borderBlue"
              v-for="(route,index) in routen"
              :key="route.id"
            >
              <NotificationSettings
                :route="route"
                :index="index"
                @save="saveNotificationEinstellungen(route, ...arguments)"
                @notificationChanged="setBenachrichtigung"
              />
            </div>
          </div>

          <div
            @click="$store.dispatch('logoutPushNotifier')"
            v-if="pushNotifierSubscribed"
            class="colorBlue borderRadius30 borderBlue borderStyleSolid borderWidth1 textcenter cursor-pointer padding10"
          >PushNotifier abmelden</div>
        </div>
        <!-- <div v-else-if="!isMobile">
              <div class="colorRed">
              Push Benachrichtigungen sind über mobile Geräte verfügbar.
              </div>
        </div>-->
        <div v-else>
          <div class="colorRed">Ihr Browser unterstützt keine Browser basierte Push Funktion.</div>
          <p>
            Sie können sich unsere Staumeldungen mit Hilfe der App
            <a
              rel="noopener noreferrer"
              href="https://pushnotifier.de/"
              target="_blank"
            >PushNotifier</a>
            auf Ihr Handy schicken lassen. Melden sie sich hierzu zunächst bei
            <a
              rel="noopener noreferrer"
              href="https://pushnotifier.de/"
              target="_blank"
            >PushNotifier</a>
            an, und laden Sie die App auf Ihr Gerät.
            <br>
            <br>Klicken Sie
            <a rel="noopener noreferrer" href="https://pushnotifier.de/signup" target="_blank">hier</a> um direkt zur Registrierung zu gelangen.
            <br>
            <br>Geben sie hier Ihre PushNotifier Anmeldedaten ein:
          </p>
          <div class="displayflex marginbottom15">
            <div
              class="backgroundGrey padding5"
              style="border-top-left-radius:5px;border-bottom-left-radius:5px;"
            >Benutzername</div>
            <input
              type="text"
              class="borderGrey borderStyleSolid borderWidth1 padding5"
              v-model="pushNotifier.username"
              placeholder="Benutzername"
              style="border-top-right-radius:5px;border-bottom-right-radius:5px;"
            >
          </div>
          <div class="displayflex marginbottom15">
            <div
              class="backgroundGrey padding5"
              style="border-top-left-radius:5px;border-bottom-left-radius:5px;"
            >Passwort</div>
            <input
              type="password"
              class="borderGrey borderStyleSolid borderWidth1 padding5"
              v-model="pushNotifier.password"
              placeholder="Passwort"
              style="border-top-right-radius:5px;border-bottom-right-radius:5px;"
            >
          </div>
          <div
            class="colorBlue borderBlue borderStyleSolid borderWidth1 borderRadius30 padding10 cursor-pointer textcenter"
            @click="pushNotifierAnmelden"
          >anmelden</div>
          <!-- <input type="password" v-model="pushNotifier.password" placeholder="Passwort"/> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleButton from "../CoreComponents/ToggleButton.vue";
import NotificationSettings from "./NotificationSettings.vue";

export default {
  name: "PushSettings",
  components: {
    NotificationSettings,
    ToggleButton
  },
  data: function() {
    return {
      extended: false,
      pushNotifier: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    pushNotifierAnmelden() {
      this.$store.dispatch("loginPushNotifier", this.pushNotifier);
    },
    saveNotificationEinstellungen(route, neueNotificationEinstellung) {
      route = Object.assign(route, neueNotificationEinstellung);
      this.$store.dispatch("saveAlleRouten", {
        parameter: "update",
        target: "route",
        data: {
          id: route.id,
          updateData: neueNotificationEinstellung
        }
      });
    },
    // Push Nachrichten Register
    handlePushRegistration(checked) {
      if (this.pushNotifierSubscribed) {
        this.$store.dispatch("setPushNotifierActiveTo", checked);
      } else {
        // subscribe/unsubscribe on click
        if (this.isSubscribed) this.unsubscribeUser();
        else this.subscribeUser();
      }
    },

    // User abonnieren
    subscribeUser() {
      this.$store.dispatch("subscribeUser");
    },

    // User will keine Nachrichten mehr empfangen
    unsubscribeUser() {
      this.$store.dispatch("unsubscribeUser");
    },

    setBenachrichtigung(route) {
      this.$store.dispatch("saveAlleRouten", {
        parameter: "update",
        target: "route",
        data: {
          id: route.id,
          updateData: {
            notification: route.notification
          }
        }
      });
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
    pushNotifierSubscribed() {
      return this.$store.state.pushNotifierSubscribed;
    },
    isSubscribed() {
      return this.$store.state.isSubscribed;
    },
    routen() {
      return this.$store.state.routen;
    },
    AlleAktivenRoutenLength() {
      return this.$store.state.routen.filter(route => route.notification)
        .length;
    },
    pushPossible() {
      return this.$store.state.pushPossible;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.PushSettingsContainer {
  height: 100%;
  width: 100%;
}

.benachrichtigungen {
  width: 100%;
  padding: 20px 0;
}

.benachrichtigungsRoutenListe {
  padding: 10px 0;
}
.benachrichtigungsRoute {
  padding: 10px 0;
  border-top-style: solid;
  border-top-width: 1px;
}

.pushSubscribeButton {
  cursor: pointer;
  padding: 10px 20px;
  margin: 10px 0;
  border-radius: 10px;
  background-color: #aeaeae;
  color: white;
}
.pushSubscribeButton.active {
  background-color: #64b5f6;
}
</style>
